// extracted by mini-css-extract-plugin
module.exports = {"Messages":"Messages_Messages__1jpwb","NoMessages":"Messages_NoMessages__8TIZD"};